import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { setConsent } from "@/lib/analytics";

export default function ConsentBanner({ consent, onChange }) {
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(false);
  useEffect(() => { if (!consent) setHidden(false); }, [consent]);
  if (consent || hidden || pathname.startsWith("/insights") || pathname.startsWith("/admin")) return null;
  const choose = (v) => { setConsent(v); onChange(v); setHidden(true); };
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.2, duration: 0.5 }}
      className="fixed bottom-4 left-4 z-[60] max-w-[340px] rounded-2xl border border-white/10 bg-[rgba(12,30,16,0.96)] p-4 text-white shadow-[0_24px_60px_-20px_rgba(0,0,0,0.8)] backdrop-blur-xl" data-testid="consent-banner" role="dialog" aria-label="Analytics preferences">
      <p className="text-[12.5px] leading-relaxed text-white/75">
        We use anonymous analytics, including a visitor ID stored on your device, to understand how people use this site and make it better.
      </p>
      <div className="mt-3 flex gap-2">
        <button type="button" onClick={() => choose("granted")} className="rounded-full bg-[#96C11F] px-4 py-1.5 text-[12px] font-bold text-[#12290F] transition-colors hover:bg-[#A6D22B]" data-testid="consent-accept-btn">Accept</button>
        <button type="button" onClick={() => choose("denied")} className="rounded-full border border-white/20 px-4 py-1.5 text-[12px] font-semibold text-white/80 transition-colors hover:bg-white/10" data-testid="consent-decline-btn">Decline</button>
      </div>
    </motion.div>
  );
}
